export const AnalyticsEvents = {
  upload: 'upload',
  tabNavigation: 'tab-navigation',
  public_id: 'public_id',
  tags: 'tags',
  uw_presets: 'uw_presets',
};
